import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  > span {
    color: #cc0000;
    font-size: 10px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    display: block;
    letter-spacing: 0px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
`;

function ErrorField({ message }) {
  return (
    <Container>
      <span>{message}</span>
    </Container>
  );
}

ErrorField.propTypes = {
  message: PropTypes.string,
};

ErrorField.defaultProps = {
  message: 'Campo obrigatório.',
};

export default ErrorField;
